import {
  Typography as CXTypography,
  ITypography as CXITypography
} from '@sanlamcx/react-ui-next-typography';

type Typography = typeof CXTypography;
export type ITypography = CXITypography;
export const Typography: Typography = CXTypography;
